var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "relative" },
    [
      _vm.prefix
        ? _c(
            "div",
            {
              staticClass:
                "absolute top-0 left-0 h-full min-w-8 flex items-center pl-1 text-gray-400",
            },
            [_vm._v(" " + _vm._s(_vm.prefix) + " ")]
          )
        : _vm._e(),
      _c(
        "FormInput",
        _vm._g(_vm._b({}, "FormInput", _vm.$attrs, false), _vm.$listeners)
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }